import { isBrowser } from './device-type';
import * as localStorage from './local-storage';
const EVENT_PREFIX = 'cross.window.event.';
// Note that this is only set in the browser, it's undefined
// when running on the server so we cannot rely on it always being
// set
let store;
// Because IE dispatches storage events also to the window that generated them,
// we keep this list of events we generate and if we encounter any of them we just ignore it.
let generatedEvents = [];
// If the list of events we generated ourselves contains more than this amount of events,
// assume that we are not getting our own events.
const MAX_EVENTS_TO_WATCH_FOR_SELF = 20;
export function setStore(s) {
    store = s;
}
const listeners = {};
if (isBrowser()) {
    let pendingCallbacks = [];
    let timer;
    const runCallbacksIfVisible = () => {
        if (document.visibilityState === 'visible' && pendingCallbacks.length) {
            console.debug('Calling cross window event callbacks because the page is visible');
            pendingCallbacks.forEach(c => c(store));
            pendingCallbacks = [];
        }
        else if (pendingCallbacks.length) {
            console.debug('Deferring calling cross window event callbacks because the page is not visible');
        }
    };
    window.addEventListener('storage', e => {
        if (e.key && e.key.indexOf(EVENT_PREFIX) === 0) {
            if (!e.newValue) {
                return;
            }
            if (generatedEvents) {
                const index = generatedEvents.indexOf(e.newValue.replace(/"/g, ''));
                if (index >= 0) {
                    generatedEvents.splice(index, 1);
                    return;
                }
            }
            const eventName = e.key.substr(EVENT_PREFIX.length);
            if (eventName in listeners) {
                listeners[eventName].forEach(c => {
                    if (pendingCallbacks.indexOf(c) === -1) {
                        pendingCallbacks.push(c);
                    }
                });
            }
            clearTimeout(timer);
            timer = setTimeout(runCallbacksIfVisible, 100);
        }
    });
    document.addEventListener('visibilitychange', runCallbacksIfVisible);
}
export function on(event, callback) {
    const eventsArray = typeof event === 'string' ? [event] : event;
    eventsArray.forEach(eventName => {
        if (!(eventName in listeners)) {
            listeners[eventName] = [];
        }
        listeners[eventName].push(callback);
    });
    return () => {
        eventsArray.forEach(eventName => {
            const index = listeners[eventName].indexOf(callback);
            if (index !== -1) {
                listeners[eventName].splice(index, 1);
            }
        });
    };
}
export function emit(event) {
    if (!store) {
        throw new Error('Cannot emit cross window event before setting the Redux store');
    }
    const eventsArray = typeof event === 'string' ? [event] : event;
    eventsArray.forEach(eventName => {
        const id = 'event' + Math.random();
        if (generatedEvents) {
            if (generatedEvents.length < MAX_EVENTS_TO_WATCH_FOR_SELF) {
                generatedEvents.push(id);
            }
            else {
                generatedEvents = null;
            }
        }
        localStorage.set(EVENT_PREFIX + eventName, id);
    });
}
